// Card.tsx
import React from 'react'
import { UserCard } from 'common/schema/users/userCards'
import '@/screens/Card.css'
import { useCachedPublicImage } from '@/helpers/urls'

interface CardProps {
  card: UserCard
  isSelected?: boolean
  onClick?: (card: UserCard) => void
}

const defaultProps = {
  isSelected: false,
  onClick: undefined,
}

export const Card: React.FC<CardProps> = ({
  card,
  isSelected = defaultProps.isSelected,
  onClick = defaultProps.onClick,
}) => {
  const cachedImageUrl = useCachedPublicImage(card.url)

  const handleClick = () => {
    if (onClick && card.status !== 'complete') {
      onClick(card)
    }
  }

  const getRarityClass = (rarity?: string) => {
    switch (rarity?.toLowerCase()) {
      case 'common':
        return 'rarity-common'
      case 'uncommon':
        return 'rarity-uncommon'
      case 'rare':
        return 'rarity-rare'
      case 'epic':
        return 'rarity-epic'
      case 'legendary':
        return 'rarity-legendary'
      default:
        return 'rarity-original'
    }
  }

  return (
    <div
      className="card-wrapper"
      style={
        {
          '--card-image-url': cachedImageUrl
            ? `url(${cachedImageUrl})`
            : 'none',
        } as React.CSSProperties
      }
    >
      <div
        className={`card ${isSelected ? 'selected' : ''} ${card.status}`}
        onClick={handleClick}
      >
        <div className="card-image" />
        {card.rarity && (
          <div className={`rarity-badge ${getRarityClass(card.rarity)}`}>
            {card.rarity}
          </div>
        )}
        <div className="card-overlay">
          {card.name && card.status !== 'unrevealed' && (
            <h3 className="card-title">{card.name}</h3>
          )}
          <h4 className="card-name">{card.collection}</h4>
          <p className="card-info">
            {card.status === 'complete'
              ? 'Complete!'
              : `Revealed ${card.timesOpened} times`}
          </p>
          {card.status !== 'complete' && (
            <div className="card-hint">Click to reveal</div>
          )}
        </div>
      </div>
    </div>
  )
}
